import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Loader2, MailOpen } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../ui/dialog';
import { api } from '../../context/AuthContext';
import { EinladungZeile } from './ErfassungEinladenDialog';

const GRUPPEN = [
  ['offen', 'Offen', (e) => e.status === 'offen' && !e.registriert],
  ['registriert', 'Registriert', (e) => e.registriert],
  ['eingegangen', 'Bogen eingegangen', (e) => e.status === 'angenommen' && !e.registriert],
  ['abgelaufen', 'Abgelaufen / zurückgezogen', (e) => ['abgelaufen', 'zurueckgezogen'].includes(e.status) && !e.registriert],
];
const datum = (iso) => (iso ? new Date(iso).toLocaleDateString('de-DE') : '');

const Registriert = ({ e }) => (
  <li className="flex items-center gap-2 py-2 text-xs" data-testid={`einladung-registriert-${e.id}`}>
    <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" />
    <span className="flex-1 min-w-0"><b className="text-[#1B3A5C]">{e.name}</b> <span className="text-gray-500">{e.email}</span>
      <span className="block text-[10px] text-gray-500">Portalkonto seit {datum(e.registriert_am) || '—'} · eingeladen am {datum(e.erstellt_am)}</span></span>
    {e.mandanten_nr && <Link to={`/kanzlei/mandanten/${e.mandanten_nr}`} className="text-[11px] text-[#b8893d] hover:underline" data-testid={`einladung-mandant-${e.id}`}>M-{e.mandanten_nr}</Link>}
  </li>
);

export const EinladungenStatus = () => {
  const [liste, setListe] = useState(null);
  const [offen, setOffen] = useState(false);
  const [gruppe, setGruppe] = useState('offen');
  const laden = useCallback(() => api.get('/kanzlei/erfassung-einladungen').then((r) => setListe(r.data.items)).catch(() => setListe([])), []);
  useEffect(() => { laden(); }, [laden]);
  const n = Object.fromEntries(GRUPPEN.map(([k, , f]) => [k, (liste || []).filter(f).length]));
  const zeige = (k) => { setGruppe(k); setOffen(true); laden(); };
  const aktiv = GRUPPEN.find(([k]) => k === gruppe);
  return (
    <>
      <button type="button" onClick={() => zeige(n.offen ? 'offen' : 'registriert')} className="inline-flex items-center gap-4 rounded-2xl border border-[#e0b56a]/40 bg-white/5 hover:bg-white/10 px-5 py-3 text-left transition-colors" data-testid="einladungen-status">
        <MailOpen className="w-5 h-5 text-[#e0b56a]" />
        <span><span className="font-serif text-3xl text-[#e0b56a]" data-testid="einladungen-offen-anzahl">{liste ? n.offen : '–'}</span><span className="block text-[11px] text-white/70 leading-tight">Einladungen offen</span></span>
        <span className="w-px h-9 bg-white/15" />
        <span><span className="font-serif text-3xl text-white" data-testid="einladungen-registriert-anzahl">{liste ? n.registriert : '–'}</span><span className="block text-[11px] text-white/70 leading-tight">registriert</span></span>
      </button>
      <Dialog open={offen} onOpenChange={setOffen}>
        <DialogContent className="max-w-xl rounded-2xl" data-testid="einladungen-dialog">
          <DialogTitle className="font-serif text-2xl text-[#1B3A5C]">Einladungen</DialogTitle>
          <DialogDescription className="text-xs">Wer eingeladen wurde, wer den Erfassungsbogen geschickt und wer schon ein Portalkonto hat.</DialogDescription>
          <div className="flex flex-wrap gap-2" role="tablist">
            {GRUPPEN.map(([k, l]) => (
              <button key={k} type="button" role="tab" aria-selected={gruppe === k} onClick={() => setGruppe(k)} data-testid={`einladungen-tab-${k}`}
                className={`h-8 px-3 rounded-full text-xs border transition-colors duration-200 ${gruppe === k ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'bg-white text-[#1B3A5C] border-gray-200 hover:border-[#b8893d]'}`}>{l} <b className="ml-1">{n[k]}</b></button>
            ))}
          </div>
          {!liste ? <Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" /> : !n[gruppe] ? <p className="text-xs text-gray-500 py-6 text-center" data-testid="einladungen-leer">Keine Einträge.</p>
            : <ul className="divide-y divide-gray-100 max-h-[50vh] overflow-y-auto" data-testid="einladungen-liste">{liste.filter(aktiv[2]).map((e) => (gruppe === 'registriert' ? <Registriert key={e.id} e={e} /> : <EinladungZeile key={e.id} e={e} onChanged={laden} />))}</ul>}
        </DialogContent>
      </Dialog>
    </>
  );
};
